import { IIndexable } from '../../model/IIndexable';
import { EmptyComponent } from './EmptyComponent';
import { BackgroundColorProps } from 'styled-system';

export interface DinamicComponentProps extends BackgroundColorProps {
  type: string;
  dictionary: IIndexable;
  data: IIndexable;
  orden: number;
  moduloTitulo?: string;
}

export function DynamicComponent(props: DinamicComponentProps) {
  const { type, dictionary, data, orden, moduloTitulo, ...otherProps } = props;
  const componentConfig = dictionary[type as keyof IIndexable];

  /** No se encuentra mapeado el componente o no hay datos*/
  if (!componentConfig || !componentConfig.mapping || !data || data.length === 0) return EmptyComponent();

  const TagNameComponent = componentConfig.component;
  const dataMapped = data.map(componentConfig.mapping);

  return <TagNameComponent data={dataMapped} orden={orden} moduloTitulo={moduloTitulo} {...otherProps} />;
}
